export class GatewayRegex {
  regexp: string = '';
  replacement: string = '';
  flags: any;
}